import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class CommonModalStore extends BaseModalStore {
  @observable text = '';

  @observable awardId = '';

  
  @observable image;

  // 底部提示
  @observable tips;

  // 奖品描述补充
  @observable desc;

  // 点击确认回调
  @observable clickSubmitCallback;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  onClickSubmit = () => {
    this.clickSubmitCallback(true);
    this.onClickClose();
  };

  use() {
    super.use();
  }
}

export default CommonModalStore;
